(ns quuppa.peweb.outputs
  (:require [clojure.string :as str]
            [quuppa.components :as c]
            [quuppa.date-time.core :as date-time]
            [quuppa.peweb.universalformat.universal-target :as peweb-ut]
            [quuppa.qpe.pe.universalformat.universal-target :as ut]
            [quuppa.qsm.permissions :as permissions]
            [quuppa.ui.button :as button]
            [quuppa.qsm.projects.subs :as ps]
            [quuppa.qsm.site.subs :as ss]
            [quuppa.ui.tooltip :as tooltip]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(defn output-row-button [props & children]
  (let [tooltip (:tooltip props)
        disabled (:disabled props)]
  (if (and tooltip disabled)
    [tooltip
     [:div
      (into [button/button
             (assoc props :small true)]
            children)]]
    (into [button/button
           (assoc props :small true)]
          children))))

(defn output-row [{:keys [class target-state content]} & buttons]
  [:div.d-flex.flex-row.justify-content-between.align-items-start
   {:class class}
   [:div.d-flex.align-items-center
    [:div.qi-circle.mx-2
     {:class (case target-state
               :success "text-success"
               :warning "text-warning"
               :error "text-error"
               "invisible")}]

    content]
   (into [:div.btn-group.flex-shrink-0] buttons)])


(defn peinfo-outputs-data-player-target
  [{:keys [qpe-dispatch qpe-subscribe]}]
  (let [project-state @(qpe-subscribe [:qpe/project-state])
        {:keys [project-id site-id]} @(rf/subscribe [:nav/match :parameters :path])
        project-entity @(rf/subscribe [::ps/project project-id])
        site-entity (when site-id
                      @(rf/subscribe [::ss/site project-id site-id]))]
    [output-row
     {:target-state (if (:data-file-target-enabled project-state)
                      :success
                      :warning)
      :content (if (:data-file-target-enabled project-state)
                 (str "Recording to folder: " (:data-file-target-folder project-state))
                 "Not active")}
     (when (or (permissions/has-manage-permission?)
               (permissions/has-manage-permission-to-site? site-entity project-entity))
       (if (:data-file-target-enabled project-state)
         [output-row-button
          {:variant "danger"
           :attr {:type "button"}
           ;; TODO: This QuuppaDataFile should be put in a def and be explained why it should be exactly this string
           :on-click #(qpe-dispatch [:qpe/control-data-player {:id "QuuppaDataFile" :enabled false}])}
          "Stop"]
         [output-row-button
          {:variant "success"
           :attr {:type "button"}
           :on-click #(qpe-dispatch [:qpe/control-data-player {:id "QuuppaDataFile" :enabled true}])}
          "Start"]))]))

(defn peinfo-outputs-udp-target
  [{:keys [qpe-dispatch qpe-subscribe]}]
  (let [{enabled? :data-udp-target-enabled :as project-state} @(qpe-subscribe [:qpe/project-state])
        {:keys [project-id site-id]} @(rf/subscribe [:nav/match :parameters :path])
        project-entity @(rf/subscribe [::ps/project project-id])
        site-entity (when site-id
                      @(rf/subscribe [::ss/site project-id site-id]))]
    [output-row
     {:target-state (if enabled?
                      :success
                      :warning)
      :content (str (if enabled?
                      "Streaming to"
                      "Not active,")
                    " IP: " (:data-udp-target-ip project-state))}

     (when (or (permissions/has-manage-permission?)
               (permissions/has-manage-permission-to-site? site-entity project-entity))
       (if enabled?
         [output-row-button
          {:variant "danger"
           :attr {:type "button"}
           :on-click #(qpe-dispatch [:qpe/control-output-target {:id "QuuppaDataUDP" :enabled false}])}
          "Stop"]
         [output-row-button
          {:variant "success"
           :attr {:type "button"}
           :on-click #(qpe-dispatch [:qpe/control-output-target {:id "QuuppaDataUDP" :enabled true}])}
          "Start"]))

     (when (or (permissions/has-manage-permission?)
               (permissions/has-manage-permission-to-site? site-entity project-entity))
       (when-not enabled?
         [output-row-button
          {:variant "primary"
           :outline true
           :attr {:type "button"}
           :on-click #(qpe-dispatch [:qpe/toggle-sidebar {:type :output-udp-target-settings
                                                          :settings {}}])}
          "Settings"]))]))

(defn peinfo-binary-logging
  [{:keys [qpe-subscribe qpe-dispatch] :as _opts}]
  (let [controller-state @(qpe-subscribe [:qpe/controller-state])
        binary-running? (-> controller-state :binary-logging :running)
        start (-> controller-state :binary-logging :start-time)
        start-instant (if (date-time/instant? start)
                        start
                        (date-time/native-date->instant (js/Date. start)))
        current-binary-folder (-> controller-state :binary-logging :subfolder)
        {:keys [project-id site-id]} @(rf/subscribe [:nav/match :parameters :path])
        project-entity @(rf/subscribe [::ps/project project-id])
        site-entity (when site-id
                      @(rf/subscribe [::ss/site project-id site-id]))]
    [output-row
     {:target-state (if binary-running?
                      :success
                      :warning)
      :content (if binary-running?
                 [:span
                  (str "Running, folder: " current-binary-folder " started ")
                  [c/date-time start-instant]]
                 "Not started")}
     (when (or (permissions/has-manage-permission?)
               (permissions/has-manage-permission-to-site? site-entity project-entity))
       (if binary-running?
         [output-row-button
          {:variant "danger"
           :attr {:type "button"}
           :on-click #(qpe-dispatch [:qpe/control-binary-logging {:enabled false}])}
          "Stop"]
         [output-row-button
          {:variant "success"
           :attr {:type "button"}
           :on-click (fn [_e]
                       (qpe-dispatch [:qpe/control-binary-logging {:enabled true}]))}
          "Start"]))]))

(defn peinfo-universal-targets
  [{:keys [target] :as target-conf} {:keys [qpe-subscribe qpe-dispatch] :as _opts}]
  (let [controller-state @(qpe-subscribe [:qpe/controller-state])
        pe-mode-stopped? (= (:pe-run-mode controller-state) :Stopped)
        kw-support? (contains? @(qpe-subscribe [:qpe/data :server-info :qpe-features]) :qpe-api/universal-target-keywords)
        current-targets (vals (if kw-support?
                                @(qpe-subscribe [:qpe/data :project-state :universal-targets target])
                                ;; backwards compatibility: target was lower cased string
                                @(qpe-subscribe [:qpe/data :project-state :universal-targets (str/lower-case (name target))])))
        target-count (count current-targets)
        {:keys [project-id site-id]} @(rf/subscribe [:nav/match :parameters :path])
        project-entity @(rf/subscribe [::ps/project project-id])
        site-entity (when site-id
                      @(rf/subscribe [::ss/site project-id site-id]))
        siteresource @(qpe-subscribe [:qsm/siteresource])]
    (into
      [:<>
       [output-row
        {:content [:span.badge.bg-secondary.fs-6.fw-medium
                   "Targets "
                   [:span.badge.text-bg-dark target-count]]}
        (when (or (permissions/has-manage-permission?)
                  (permissions/has-manage-permission-to-site? site-entity project-entity))
          [output-row-button
           {:start-icon :plus
            :attr {:type "button"}
            :tooltip (fn [child-element]
                       [tooltip/overlay-trigger
                        {:placement "top"
                         :rootClose true
                         :trigger "click"
                         :overlay (r/as-element
                                    [tooltip/tooltip
                                     {:id "tooltip-create-target-disabled"}
                                     "QPE needs to be running first"])}
                        child-element])
            :disabled pe-mode-stopped?
            :on-click #(qpe-dispatch [:qpe/toggle-sidebar {:type :create-universal-target
                                                           :id target
                                                           :ut (cond (= target :Websocket)
                                                               (assoc (ut/make-universal-target {:target target}) :WebsocketScheme "ws" :new-target-key (random-uuid))
                                                               (= target :MQTT)
                                                               (assoc (ut/make-universal-target {:target target}) :MQTTScheme "tcp" :new-target-key (random-uuid) :certificate-validation "server")
                                                               :else (assoc (ut/make-universal-target {:target target}) :new-target-key (random-uuid)))
                                                           :settings (assoc target-conf :kw-support? kw-support?)}])}
           "Create target"])]]

      (for [{target-name :name, :keys [enabled MQTTScheme MQTTAddress MQTTAuthType retain certificate-validation target id
                                       client-key-passphrase WebsocketScheme WebsocketAddress WebsocketAuthorizationType] :as t} current-targets
            :let [MQTTScheme (if (= MQTTScheme "ssl")
                                    "ssl/tls"
                                    MQTTScheme)]]
        ;; NOTE: target's name is considered unique, it is identifier!!!
        ^{:key target-name}
        [output-row
         {:class "my-1"
          :target-state (if enabled
                          :success
                          :warning)
          :content (peweb-ut/target-row-content t)}

         (when (or (permissions/has-manage-permission?)
                   (permissions/has-manage-permission-to-site? site-entity project-entity))
           [output-row-button
            {:variant (if enabled "danger" "success")
             :attr {:type "button"}
             :on-click #(qpe-dispatch [:qpe/control-universal-target {:name target-name
                                                                      :mode (if enabled "stop" "start")}])}
            (if enabled "Stop" "Start")])
         (when (or (permissions/has-manage-permission?)
                   (permissions/has-manage-permission-to-site? site-entity project-entity))
           [output-row-button
            {:variant "primary"
             :outline true
             :attr {:type "button"}
             :on-click (fn []
                         (when siteresource
                           (qpe-dispatch [:qsm/clear-siteresources]))
                         (when (and (= target :MQTT)
                                    (some #{MQTTScheme} ["ssl/tls" "wss"]))
                           (qpe-dispatch [:qsm/get-siteresource-by-target-id id]))
                         ;; A support for older QPEs, so that if there are already client certificates associated then we show 'client' option
                         (let [certificate-validation (if (and (nil? certificate-validation) siteresource)
                                                        "client"
                                                        certificate-validation)]
                           (qpe-dispatch [:qpe/toggle-sidebar {:type :control-universal-target
                                                               :id target-name
                                                               :ut (merge
                                                                     {:name target-name}
                                                                     (when (= target :MQTT)
                                                                       {:retain (boolean retain)})
                                                                     (when MQTTScheme
                                                                       {:MQTTScheme MQTTScheme})
                                                                     (when MQTTAddress
                                                                       {:MQTTAddress MQTTAddress})
                                                                     (when MQTTAuthType
                                                                       {:MQTTAuthType MQTTAuthType})
                                                                     (when WebsocketScheme
                                                                       {:WebsocketScheme WebsocketScheme})
                                                                     (when WebsocketAddress
                                                                       {:WebsocketAddress WebsocketAddress})
                                                                     (when WebsocketAuthorizationType
                                                                       {:WebsocketAuthorizationType WebsocketAuthorizationType})
                                                                    (when client-key-passphrase
                                                                      {:client-key-passphrase client-key-passphrase})
                                                                     (when certificate-validation
                                                                       {:certificate-validation certificate-validation}))
                                                               :current (ut/make-universal-target t)
                                                               :settings (assoc target-conf :kw-support? kw-support?)}])))}
            "Settings"])]))))
